import type { Link } from '@/types';
import * as Styled from './CheckoutFooter.styled';

interface CheckoutFooterProps {
  links: Link[];
}

export const CheckoutFooter = ({ links }: CheckoutFooterProps) => (
  <Styled.Footer>
    {links.map(link =>
      link.href ? (
        <Styled.FooterLink
          className="checkout-footer"
          href={link.href}
          key={link.href}
          target="_blank"
        >
          {link.label}
        </Styled.FooterLink>
      ) : null,
    )}
  </Styled.Footer>
);
